import { Button, type ButtonProps } from "@mui/material";
import { MenuBook as MenuBookIcon } from "@mui/icons-material";
import { styled } from "@mui/material/styles";

interface Props extends ButtonProps {
  docsPath: string;
}

export function ButtonDocs(props: Props) {
  return (
    <StyledButton
      href={`${window._env_.REACT_APP_DOCS_URL}/${props.docsPath}`}
      target="_blank"
      variant="outlined"
      endIcon={<MenuBookIcon />}
      color="inherit"
    >
      {props.children}
    </StyledButton>
  );
}
type StyledButtonProps = ButtonProps & {
  target?: React.HTMLAttributeAnchorTarget;
  rel?: string;
};

export const StyledButton = styled(Button)<StyledButtonProps>`
  background-color: white;
  border: 1px solid ${({ theme }) => theme.palette.grey[300]};
  color: ${({ theme }) => theme.palette.grey[700]};

  .MuiSvgIcon-root {
    transform: translateY(-1px);
  }
`;
